import { render, staticRenderFns } from "./desktop-nav-auth.vue?vue&type=template&id=6b7747f5&"
import script from "./desktop-nav-auth.vue?vue&type=script&lang=ts&"
export * from "./desktop-nav-auth.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports